// @ts-nocheck
import Sheet from 'atoms/sheet/sheet';
import SheetBody from 'atoms/sheet/sheetBody/sheetBody';
import * as dynamicGridSagaActions from 'models/dynamicGrid/sagaActions';
import * as dynamicGridSelectors from 'models/dynamicGrid/selector';
import Stack from 'molecules/stack/stack';
import StackItem from 'molecules/stackItem/stackItem';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ThetaGridPaginated from 'templates/thetaGridPaginated';

import * as constants from './constants';
import { triggerDeleteColumnAlias } from './sagaActions';
import CreateColumnAliasInfo from './components/createColumnAliasInfo';
import Breadcrumbs from 'atoms/breadcrumbs/breadcrumbs';
import { REQUESTS } from 'utils/services/thetaretail/requests';
import { isAppAliasSettingDelete } from '../../../models/user/selector';
import GridActionBar from 'atoms/GridActionBar';
import { fetchBookmarksList } from 'models/bookmarks/sagaActions';
import Button from 'atoms/button/button';
import DeleteModal from 'components/DeleteModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import { Button as AntButton, Tooltip } from 'antd';

export interface TProps {
	title?: string;
}

const ColumnAliases: React.FunctionComponent<TProps> = (props: TProps) => {
	const [openFilter, setOpenFilter] = React.useState<boolean>();
	const [showModal, setShowModal] = React.useState<boolean>(false);
	const [rowId, setRowId] = React.useState<string>(null);
	const dispatch = useDispatch();
	const hasDeleteAccess = useSelector(isAppAliasSettingDelete);

	const hasSearchFilters = useSelector((state) =>
		dynamicGridSelectors.hasSearchFilters(state, constants.COLUMNS_TABLE_ID)
	);

	React.useEffect(() => {
		if (openFilter === undefined) {
			setOpenFilter(hasSearchFilters);
		}
	}, [hasSearchFilters]);

	React.useEffect(() => {
		dispatch(dynamicGridSagaActions.erpEnabled({ tableId: constants.COLUMNS_TABLE_ID }));
		dispatch(fetchBookmarksList({ tableId: constants.COLUMNS_TABLE_ID }));
	}, [dispatch]);

	const handleRefreshClick = React.useCallback(() => {
		dispatch(
			dynamicGridSagaActions.refreshGridData({
				tableId: constants.COLUMNS_TABLE_ID,
			})
		);
	}, []);

	const gridConfig = {
		enableSelection: true,
		enableSorting: true,
		enableMultiSort: true,
		selectionCallBack: () => {},
		customActions: hasDeleteAccess && {
			width: 170,
			enabled: true,
			component: ({ row }) => {
				return (
					<Stack gutter="small" align="center" position="center">
						<StackItem>
							{/* <Icon
                isActive
                type="secondary"
                size="small"
                disabled={row?.IsReadOnly}
                onClick={() => {
                  dispatch(
                    triggerDeleteColumnAlias({
                      isSelectAll: false,
                      ColumnName: row.id,
                    })
                  );
                }}
                faAlias={"faTrash"}
              /> */}
							<Stack className="tbl-action-buttons">
								<Button
									disabled={row?.IsReadOnly}
									handleClick={() => (setShowModal(true), setRowId(row.id))}
								>
									{' '}
									<i className="icon-trash" />
								</Button>
							</Stack>
						</StackItem>
					</Stack>
				);
			},
		},
	};

	const templateConfig = React.useMemo(
		() => ({
			gridConfig,
			tableId: constants.COLUMNS_TABLE_ID,
			isFilterEnabled: openFilter === undefined ? false : openFilter,
			dataProviderOptions: {
				type: 'POST',
				version: 2,
				pathParams: { tableId: constants.COLUMNS_TABLE_ID },
				...REQUESTS.POST.GET_COLUMN_ALIAS,
			},
			selectRowKey: 'AppColumnID',
		}),
		[showModal]
	);

	return (
		<React.Fragment>
			<Stack isVertical gutter="tiny">
				<StackItem>
					<GridActionBar>
						<div className="content-head">
							<Stack gutter="medium" align="space-between">
								<div className="content-head-lt">
									<Breadcrumbs crumbs={props.breadcrumbs} />
								</div>
								<div className="content-head-rt">
									<Stack gutter="medium" className="action-btns">
										<StackItem className="action-btn">
											<CreateColumnAliasInfo />
										</StackItem>
										<StackItem className="action-btn">
											<Tooltip title="Refresh">
												<AntButton
													className="menu-action--button"
													icon={
														<FontAwesomeIcon className="font-icon" icon={faArrowsRotate} />
													}
													onClick={handleRefreshClick}
												/>
											</Tooltip>
										</StackItem>
									</Stack>
								</div>
							</Stack>
						</div>
					</GridActionBar>
				</StackItem>
				<StackItem isStretch isGrow>
					<Sheet isPage className="order-tbl">
						<Stack isVertical gutter="small">
							<StackItem isStretch isGrow>
								<Stack isVertical>
									<StackItem isGrow>
										<SheetBody>
											<ThetaGridPaginated
												key={constants.COLUMNS_TABLE_ID}
												config={templateConfig}
											/>
										</SheetBody>
									</StackItem>
								</Stack>
							</StackItem>
						</Stack>
					</Sheet>
				</StackItem>
			</Stack>
			{showModal && (
				<DeleteModal
					success={() => {
						dispatch(
							triggerDeleteColumnAlias({
								isSelectAll: false,
								ColumnName: rowId,
							})
						);
					}}
					hideModal={() => setShowModal(false)}
				/>
			)}
		</React.Fragment>
	);
};

export default ColumnAliases;
